// Single source of truth for OAuth storage keys, endpoints, redirect URI and timing windows.

export const OAUTH_CLIENT_ID = 'oauth_client_id';
export const OAUTH_REFRESH_TOKEN = 'oauth_refresh_token';
export const OAUTH_CODE_VERIFIER = 'oauth_code_verifier';
export const OAUTH_STATE = 'oauth_state';
export const OAUTH_RETURN_TO = 'oauth_return_to';

export const REFRESH_WINDOW_MS = 300_000;
export const ACTIVITY_WINDOW_MS = 900_000;

export const OAUTH_SCOPE = 'user mcp';
export const CLIENT_NAME = 'Title Web App';

export const redirectUri = () => `${window.location.origin}/oauth/callback`;

// Read at call time (not module load) so tests can stub the env.
const apiBase = (): string => import.meta.env.VITE_API_BASE_URL ?? '';

export const isOAuthConfigured = (): boolean => apiBase().trim() !== '';

// The one base-URL join: tolerates a base with or without trailing slash.
const endpoint = (path: string): string => `${apiBase().replace(/\/+$/, '')}/${path}`;

export const oauthRegisterUrl = () => endpoint('oauth/register');
export const oauthAuthorizeUrl = () => endpoint('oauth/authorize');
export const oauthTokenUrl = () => endpoint('oauth/token');
export const oauthRevokeUrl = () => endpoint('oauth/revoke');
export const wopiTokenUrl = () => endpoint('wopi/token');
export const loginRedeemUrl = () => endpoint('s/login/redeem');
export const uploadRedeemUrl = () => endpoint('s/upload/redeem');
